import type { OrderByFields, EOrderDirectionType } from '../../types';

import { CLAUSE_KEYWORD_BOUNDARY } from '../configs';

export interface IBuildOrderByQueryParams {
  orderBy?: OrderByFields;
}

const build = (orderBy?: OrderByFields, columns?: string[]) => {
  if (!orderBy) return '';

  const orderByQuery = Object.values(orderBy)
    .filter((item) => columns?.includes(item.field))
    .map((item) => `${item.field} ${item.direction}`)
    .join(', ');

  return orderByQuery ? `ORDER BY ${orderByQuery}` : '';
};

const parse = (query: string): OrderByFields | undefined => {
  const match = query.match(
    new RegExp(`\\bORDER BY\\s+([\\s\\S]+?)(?=\\s+(?:${CLAUSE_KEYWORD_BOUNDARY})\\b|$)`, 'i'),
  );
  if (!match) return undefined;

  const orderBy: OrderByFields = {};
  match[1].split(',').forEach((item) => {
    const parts = item.trim().split(/\s+/);
    if (parts.length === 2) {
      const [field, direction] = parts;
      orderBy[field] = { field, direction: direction as EOrderDirectionType };
    }
  });

  return Object.keys(orderBy).length > 0 ? orderBy : undefined;
};

export { build as buildOrderByQuery, parse as parseOrderByQuery };
